import styled from 'styled-components';

import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';

/*
  ## Destaques ##
*/

export const H1 = styled.h1`
  color: ${COLOR.GREEN_1};
  font-size: 30px;
  font-weight: 600;
  line-height: 125%;
  text-transform: uppercase;
  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    font-size: 34px;
  }
  /* Desktop */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    font-size: 38px;
  }
`;

/*
  ## Títulos principais ##
*/

export const H2 = styled.h2`
  color: ${COLOR.GREY_1};
  font-size: 24px;
  font-weight: 600;
  line-height: 125%;
  text-transform: uppercase;
  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    font-size: 26px;
  }
  /* Desktop */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    font-size: 28px;
  }
`;

/*
  ## Títulos secundários ##
*/

export const H3 = styled.h3`
  color: ${COLOR.GREY_1};
  font-size: 18px;
  font-weight: 500;
  line-height: 125%;
  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    font-size: 20px;
  }
  /* Desktop */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    font-size: 22px;
  }
`;

/*
  ## Textos gerais ##
*/

export const Paragraph = styled.p`
  color: ${COLOR.GREY_1};
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    font-size: 18px;
  }
  /* Desktop */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    font-size: 20px;
  }
`;

/*
  ## Observações ##
*/

export const Comment = styled.p`
  color: ${COLOR.GREY_1};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  /* Ipad-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    font-size: 16px;
  }
   /* Desktop */
   @media screen and (min-width: ${BREAKPOINT.MD}) {
    font-size: 18px;
  }
`;
